import { render } from "./MemberDetails.vue?vue&type=template&id=24fbd93e&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=js"
export * from "./MemberDetails.vue?vue&type=script&lang=js"

import "./MemberDetails.vue?vue&type=style&index=0&id=24fbd93e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fbd93e"]])

export default __exports__